module.exports = __webpack_public_path__ + "static/Fisherman-Logo-NoText-a1a6cd7917dd7c972ce196e76010eeab.png";